import { getAllPanelLiveStates } from '@/stores/panel-state-registry'

/** Tickers sent per list: enough to tell same-named lists apart. */
const MAX_TICKERS = 50

/**
 * The watchlists the trader's Watchlist panels show right now (each panel
 * publishes `watchlist`, its list's name, and `tickers`; watchlist-panel.tsx).
 * The analyst's watchlist tools read "my watchlist" as the one on screen, and
 * the tickers tell lists that share a name apart (2026-10-18).
 */
export function onScreenWatchlists(): Array<{ name: string; tickers: string[] }> {
  const out: Array<{ name: string; tickers: string[] }> = []
  for (const state of getAllPanelLiveStates().values()) {
    if (typeof state.watchlist !== 'string' || !state.watchlist) continue
    const tickers = Array.isArray(state.tickers)
      ? state.tickers.filter((t): t is string => typeof t === 'string').slice(0, MAX_TICKERS)
      : []
    out.push({ name: state.watchlist, tickers })
  }
  return out.slice(0, 20)
}
